import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-round",
  "use": "plus-round-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"plus-round\"><path fill=\"#fff\" stroke=\"currentColor\" stroke-width=\"1.3\" d=\"M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10z\" /><path fill=\"currentColor\" stroke=\"currentColor\" d=\"M10.444 6h1.122v4.44h4.439v1.12h-4.44V16h-1.12v-4.44h-4.44v-1.12h4.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol